<template>
  <e-dialog ref="dialogRef" @open="onOpen">
    <template #title>
      <e-icon name="editPen" class="mr-2" />
      <span class="caption"> Редактировать выбранные</span>
    </template>
    <div class="mass-operations-dialog__container">
      <template v-for="header in editableHeaders" :key="header.key">
        <e-input
          v-if="header.editable!.type === EditableHeaderType.Input"
          v-model:number-value="header.editable!.value as number | null"
          :label="header.editable!.title"
          @update:number-value="header.editable!.isDirty = true"
        />
        <e-checkbox
          v-if="header.editable!.type === EditableHeaderType.Checkbox"
          v-model="header.editable!.value as boolean"
          :square-selected="checkSelectedCounts(header.editable!.editableKey as Paths<T>).partial"
          :label="header.editable!.title"
          @update:model-value="header.editable!.isDirty = true"
        />
        <e-select
          v-if="header.editable!.type === EditableHeaderType.Select"
          v-model="header.editable!.value"
          :label="header.editable!.title"
          :items="header.editable!.selectOptions!"
          @update:model-value="header.editable!.isDirty = true"
        />
      </template>
    </div>

    <template #buttons>
      <e-btn variant="secondary" @click="close">Отмена</e-btn>
      <e-btn variant="primary" @click="apply">Применить</e-btn>
    </template>
  </e-dialog>
</template>

<script setup lang="ts" generic="T extends Record<string, unknown>, K extends Paths<T> | undefined">
import { ref } from 'vue';
import type { Paths } from '@/core/types/gengeric';
import EDialog from '@/core/components/modals/Dialog.vue';
import { EBtn, ECheckbox, EIcon, EInput, ESelect } from '@/core/components/ui';
import { type DataTableHeaders, EditableHeaderType } from '@/core/types/components/table';
import { setNestedProperty } from '@/core/utils/object';

const props = defineProps<{
  editableHeaders: DataTableHeaders;
  checkSelectedCounts: (key: Paths<T>) => {
    partial: boolean;
    all: boolean;
  };
}>();

const selected = defineModel<K extends Paths<T> ? T[K][] : T[]>();

const dialogRef = ref();

const close = () => {
  dialogRef.value?.close();
};

const apply = () => {
  selected.value?.forEach((item) => {
    props.editableHeaders.forEach((header) => {
      if (header.editable!.isDirty || header.editable!.type !== EditableHeaderType.Checkbox) {
        setNestedProperty(item as Record<string, unknown>, header.editable!.editableKey, header.editable!.value);
      }
    });
  });
  close();
};

const onOpen = () => {
  props.editableHeaders.forEach((header) => {
    header.editable!.isDirty = false;

    if (header.editable!.type === EditableHeaderType.Checkbox) {
      header.editable!.value = props.checkSelectedCounts(header.editable!.editableKey as Paths<T>).all;
    }
  });
};

defineExpose({
  show: () => dialogRef.value.show(),
});
</script>

<style scoped lang="scss">
.mass-operations-dialog {
  &__container {
    display: flex;
    flex-direction: column;
    gap: 24px;

    max-width: 280px;
  }
}
</style>
